import React, { useState, useEffect } from 'react';
import IntlMessages from '../../../util/IntlMessages';
import UtilService from '../../../services/util';
import _ from 'lodash';
import OpenNotification from '../CommonButton/OpenNotification';
import { DOWNLOAD_ZIP_EXCEL } from '../../../constants/apiConstant';
import { BASE_URL } from '../../../constants/Common';

const DownloadDropdown = (props) => {
  const [downloadPath, setDownloadPath] = useState('');
  const [option, setOption] = useState([]);
  const [ind, setInd] = useState([1]);

  useEffect(() => {
    if (downloadPath !== '') {
      window.open(downloadPath, 'Download');
      setDownloadPath('');
    }
  }, [downloadPath]);

  useEffect(() => {
    let checked = [];
    if (props.checked && props.checked.length !== 0) {
      checked = props.checked;
    } else if (props.noCheckedForDownload && props.noCheckedForDownload.length !== 0) {
      checked = props.noCheckedForDownload;
    }
    if (checked && checked.length !== 0) {
      setOption([
        { index: 1, title: 'Certificate' },
        { index: 2, title: 'Real Image' },
        { index: 4, title: 'Heart' },
        { index: 5, title: 'Arrow' },
        { index: 6, title: 'Video' },
        { index: 7, title: 'Light' },
      ]);
    }
  }, [props.checked, props.noCheckedForDownload]);

  const ShareOption = (props) => (
    <li onClick={props.onClick} className={props.activeClass}>
      <div className="dropdownBottomItem">
        <span className="shareOptionLabel">{props.title}</span>
      </div>
    </li>
  );

  const onDownloadClick = () => {
    let checked = [];
    if (props.checked && props.checked.length !== 0) {
      checked = props.checked;
    } else if (props.noCheckedForDownload && props.noCheckedForDownload.length !== 0) {
      if (!props.fromList) {
        checked = props.noCheckedForDownload;
      }
    } else {
      OpenNotification({
        type: 'error',
        title: 'No stone(stones) to download.',
      });
    }
    // if (checked && checked.length !== 0) {
    const obj = {
      isExcel: false,
      img: false,
      certFile: false,
      mp4Video: false,
      hAFile: false,
      arrowFile: false,
      assetFile: false,
      faceUp: false,
      zip: true,
    };
    ind.map((num) => {
      if (num === 0) {
        obj.isExcel = true;
      }
      if (num === 1) {
        obj.certFile = true;
      }
      if (num === 2) {
        obj.img = true;
      }
      if (num === 5) {
        obj.arrowFile = true;
      }
      if (num === 4) {
        obj.hAFile = true;
      }
      // if (num === 5) {
      //     obj.assetFile = true
      // }
      if (num === 6) {
        obj.mp4Video = true;
      }
      if (num === 7) {
        obj.faceUp = true;
      }
    });
    let id = _.map(checked, 'vStnId');
    if (props.checked && props.checked.length === 1) {
      if (ind && ind.length === 1) {
        obj.zip = true;
      }
    }
    if (
      obj.isExcel === true &&
      obj.arrowFile === false &&
      obj.assetFile === false &&
      obj.certFile === false &&
      obj.faceUp === false &&
      obj.hAFile === false &&
      obj.img === false &&
      obj.mp4Video === false
    ) {
      let objData = {
        ...DOWNLOAD_ZIP_EXCEL,
        request: {
          filter: _.isEmpty(id) ? { ...props.filter, wSts: ['A', 'M', 'H'] } : { vStnId: [...id] },
          ...obj,
          zip: false,
        },
      };
      UtilService.callApi(objData, async function (err, data) {
        if (err) throw err;
        if ((await data) && data.code === 'OK') {
          let server = BASE_URL;
          if (data.data) {
            if (_.isArray(data.data) && data.data.length !== 0) {
              data.data.map((url) => {
                let file_path = `${server}/${url}`;
                setDownloadPath(file_path);
              });
            } else {
              let file_path = `${server}/${data.data}`;
              setDownloadPath(file_path);
            }
            if (props.clearAll) props.clearAll();
            props.onCloseDownloadPopup();
          }
        }
      });
    } else {
      let objData = {
        ...DOWNLOAD_ZIP_EXCEL,
        request: {
          filter: _.isEmpty(id)
            ? { isFcCol: false, ...props.filter, wSts: ['A', 'M', 'H'] }
            : { vStnId: [...id], isFcCol: false },
          ...obj,
        },
      };
      UtilService.callApi(objData, async function (err, data) {
        if (err) throw err;
        if ((await data) && data.code === 'OK') {
          let server = BASE_URL;
          if (data.data) {
            if (_.isArray(data.data) && data.data.length !== 0) {
              data.data.map((url) => {
                let file_path = `${server}/${url}`;
                setDownloadPath(file_path);
              });
            } else {
              let file_path = `${server}/${data.data}`;
              setDownloadPath(file_path);
            }
            if (props.clearAll) props.clearAll();
            props.onCloseDownloadPopup();
          }
        }
      });
    }
    // handleDownloadMultiple({}, _.map(checked, "id"), { ...obj }, (status) => {
    //     if (status) {
    //         props.clearAll();
    //     }
    // });

    // }
  };
  // console.log('option :>> ', option);
  return (
    <>
      <div>
        <div className="searchPopupCommon">
          <div className="shareOptionSet d-flex">
            <div className="shareOptionSetItem">
              <ul>
                {option &&
                  option.length !== 0 &&
                  option.map((op, index) => (
                    <ShareOption
                      key={index}
                      onClick={() => {
                        let tempIndex = ind;
                        if (tempIndex.includes(op.index)) {
                          if (tempIndex.length !== 1) {
                            tempIndex = tempIndex.filter((d) => d !== op.index);
                          }
                        } else {
                          tempIndex.push(op.index);
                        }
                        setInd([...tempIndex]);
                      }}
                      activeClass={ind.includes(op.index) ? 'active' : ''}
                      title={op.title}
                    />
                  ))}
              </ul>
            </div>
          </div>
          <div className="commonModalButton mt-20">
            {ind && ind.length !== 0 && ind.length >= 2 ? (
              props.checked && props.checked.length !== 0 ? (
                <button onClick={onDownloadClick} className="fillButton">
                  <IntlMessages id="app.Download" />
                </button>
              ) : (
                <button className="fillButton">Please select diamonds</button>
              )
            ) : ind.includes(0) ? (
              <button onClick={onDownloadClick} className="fillButton">
                <IntlMessages id="app.Download" />
              </button>
            ) : props.checked && props.checked.length !== 0 ? (
              <button onClick={onDownloadClick} className="fillButton">
                <IntlMessages id="app.Download" />
              </button>
            ) : (
              <button className="fillButton">Please select diamonds</button>
            )}

            <button onClick={() => props.onCloseDownloadPopup()} className="outLineButton ml-5">
              <IntlMessages id="app.Cancel" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
export default DownloadDropdown;
